module.exports = __webpack_public_path__ + "static/infantil-3909a68e1dafad9ceb0bda2426e3adf4.jpg";